import {DropdownOption} from "src/components/wim/utils/ticket-utils";


export const pillarOptions: DropdownOption[] = [
    { value: "UBC", label: "UBC" },
    { value: "SDO", label: "SDO" },
    { value: "SCI", label: "SCI" },
    { value: "SABE", label: "SABE" }
];

export const ERROR_MESSAGES = {
    AUTHENTICATION_ERROR: 'User not authenticated. Please log in.',
    INVALID_WORK_ITEM_TYPE: 'Invalid workitem type selected',
    CREATE_TICKET_FAILURE: 'Failed to create Workitem',
    UNKNOWN_ERROR: 'Unknown error occurred'
};

export const SUCCESS_MESSAGES = {
    TICKET_CREATED: 'Workitem is created , and will be assigned to you via zeus promptly!'
};

export const FORM_LABELS = {
    TITLE: 'Title*',
    DESCRIPTION: 'Description',
    PILLAR: 'Pillar*',
    SYSTEM: 'System*',
    WORK_ITEM_TYPE: 'WorkItem Type*',
    CAPABILITY_PRIMITIVE: 'Capability Primitive*',
    PROCESS_PRIMITIVE: 'Process Primitive*',
    PROGRAM: 'Program*'
};

export const PLACEHOLDERS = {
    TITLE: 'Enter workitem title',
    DESCRIPTION: 'Enter workitem description',
    PILLAR: 'Select a pillar',
    SYSTEM: 'Select a system',
    WORK_ITEM_TYPE: 'Select workitem type',
    CAPABILITY: 'Capability Primitive will be auto-populated',
    PROCESS: 'Process Primitive will be auto-populated',
    PROGRAM: 'Program will be auto-populated'
};

export const BUTTON_LABELS = {
    CANCEL: 'Cancel',
    CREATE_TICKET: 'Create Workitem'
};

export const ALERT_HEADERS = {
    ERROR: 'Error creating ticket',
    SUCCESS: 'Success'
};

export const DEFAULT_VALUES = {
    PRIORITY: 3,
    CONTEXT_TYPE: 'ADHOC_TICKET',
    DEFAULT_DESCRIPTION: 'Adhoc Workitem created via UI',
    IS_OUTPUT_REQUIRED: false
};

export interface TicketPayload {
    workItemId: string;
    context: {
        contextId: string;
        contextType: string;
    };
    title: string;
    description: string;
    priority: number;
    requester: {
        name: string;
    };
    workForce: {
        sim: {
            category: string;
            type: string;
            item: string;
            resolverGroup: string;
            simFolderId: string;
            user: string;
        };
    };
    tags: { [key: string]: string };
    isOutputRequired: boolean;
}